import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import CreateAccountTermsOfService from './CreateAccountTermsOfService';
import { StyledUILink } from './TextInput.styles';
import { usePrivacyBanner } from './usePrivacyBanner';
import { useCurrentStep } from '../hooks/useCurrentStep';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';

const SkipStep = ({
  handleSkip,
  stepKey,
  disabled = false
}) => {
  const {
    shouldShowToSOptionalStep
  } = usePrivacyBanner();
  const message = shouldShowToSOptionalStep ? 'common.skip-step-create-account' : 'common.skip-this-step';
  const {
    currentStep
  } = useCurrentStep();
  const customLinkLabelI18n = `views.${currentStep}.skipLinkLabel`;
  const linkLabel = isValidI18nKey(customLinkLabelI18n) ? customLinkLabelI18n : message;
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-5 text-center",
    children: [/*#__PURE__*/_jsx(StyledUILink, {
      "data-selenium": `${stepKey}_skipLink`,
      disabled: disabled,
      href: "",
      onClick: event => {
        event.preventDefault();
        handleSkip();
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: linkLabel
      })
    }), shouldShowToSOptionalStep && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
  });
};

export default SkipStep;